<template>
    <div>
        <h2>{{ $t("wp.authenticating") }}</h2>
        <div class="d-flex justify-content-center align-items-center" style="font-size: 22px">
            <div>
                <div>{{ $t("wp.activationTitle") }}</div>
                <ol>
                    <li>{{ $t("wp.wpIntegrationInstruction1") }}</li>
                    <li v-if="$i18n.locale === 'tr'">
                        Menü <a-icon type="more" /> veya Ayarlar <a-icon type="setting" /> seçeneğine dokunup
                        <b>Bağlı Cihazlar'ı</b> seçin.
                    </li>
                    <li v-if="$i18n.locale === 'en'">
                        Tap Menu
                        <a-icon type="more" />
                        or Settings
                        <a-icon type="setting" />
                        and select
                        <b>Linked Devices</b>.
                    </li>
                    <li v-if="$i18n.locale === 'ru'">
                        Нажмите Меню <a-icon type="more" /> или Настройки <a-icon type="setting" /> и выберите
                        <b>Связанные устройства</b>.
                    </li>
                    <li>{{ $t("wp.wpIntegrationInstruction3") }}</li>
                </ol>
            </div>
            <div v-if="isQRCodeGenerating" class="p-3 d-flex flex-column justify-content-center align-items-center">
                <span class="text-info">{{ $t("wp.qrGeneratingWait") }}</span>
                <md-progress-spinner
                    class="md-accent text-danger"
                    :md-diameter="20"
                    md-mode="indeterminate"
                ></md-progress-spinner>
            </div>
            <div v-if="isAuthenticating" class="p-3 d-flex flex-column justify-content-center align-items-center">
                <span class="text-info">{{ $t("wp.authenticatingWait") }}</span>
                <md-progress-spinner
                    class="md-accent text-danger"
                    :md-diameter="20"
                    md-mode="indeterminate"
                ></md-progress-spinner>
            </div>
            <div v-if="isQRCodeGenerated">
                <img :src="getQRAddress()" alt="QR Code" class="qr-code" :key="imageRefreshKey" />
            </div>
        </div>
        <div v-if=" continueToWait" class="p-3 d-flex flex-column justify-content-center align-items-center">
            <span class="text-info">{{$t("wp.pleaseContinueToWaitUntilCompleted")}}</span>
            <md-progress-spinner
                :md-diameter="20"
                :md-stroke="3"
                md-mode="indeterminate"
            ></md-progress-spinner>
        </div>
    </div>
</template>

<script>
import { getPersistenceData } from "../../utils/persistenceStorage";
import CONFIG from "../../config/config";
import { mapActions, mapGetters, mapState } from "vuex";

const LSTATES = CONFIG.WHATSAPP.LAUNCH_STATES;
export default {
    name: "QRCodeAuthentication",
    data() {
        return {
            imageRefreshKey: 0,
            continueToWait: false,
        };
    },

    computed: {
        ...mapState({
            settings: (state) => state.setting.settings,
            isSettingInitialized: (state) => state.setting.initialized,
            site: (state) => state.site.site,
            initialized: (state) => state.whatsapp.info.initialized,
            status: (state) => state.whatsapp.info.status,
            isQRCodeGenerating: (state) =>
                state.whatsapp.info.status.status.LAUNCH_STATE === LSTATES.QR_CODE_GENERATING,
            isQRCodeGenerated: (state) => state.whatsapp.info.status.status.LAUNCH_STATE === LSTATES.QR_CODE_GENERATED,
            isAuthenticating: (state) => state.whatsapp.info.status.status.LAUNCH_STATE === LSTATES.AUTHENTICATING,
        }),
    },

    methods: {
        getQRAddress() {
            this.continueToWait = true;
            setTimeout(() => {
                this.continueToWait = false;
            }, 4000);
            return `${CONFIG.WHATSAPP.qrAddress}?siteId=${this.site._id}&token=${getPersistenceData("Admin-Token")}&r=${
                Math.random() * 1000
            }`;
        },
    },
    mounted() {
        this.timerId = setInterval(() => {
            this.imageRefreshKey++;
        }, 5000);
    },
    beforeDestroy() {
        clearInterval(this.timerId);
    },
};
</script>

<style scoped>
.qr-code {
    width: 150px;
    height: 150px;
    animation: colorAnim 1s infinite linear;
}

@keyframes colorAnim {
    from {
        filter: hue-rotate(0deg);
    }
    to {
        filter: hue-rotate(360deg);
    }
}
</style>
